// extracted by mini-css-extract-plugin
export var discard = "_51-3";
export var muiTooltipTooltip = "_51-5";
export var notificationBar = "_51-2";
export var saveButtonHoverSlotWrapper = "_51-4";
export var show = "_51-1";
export var spacer = "_51-0";